import { useHydrateAuthAtoms } from '@/atoms/auth';
import type { ReactNode } from 'react';
import type { Permission, Role } from '@/types/auth';
interface AuthData {
  permissions: Permission[];
  roles: Role[];
}
interface AuthHydrationProviderProps {
  auth: AuthData | undefined;
  children: ReactNode;
}
const AuthHydrator = ({
  auth,
  children
}: {
  auth: AuthData;
  children: ReactNode;
}) => {
  useHydrateAuthAtoms(auth);
  return children;
};

/**
 * Hydrates Jotai auth atoms from `pageProps.__auth` injected by `withServerAuth()`.
 * No-op when `auth` is undefined (pages not using `withServerAuth`).
 */
export const AuthHydrationProvider = ({
  auth,
  children
}: AuthHydrationProviderProps) => {
  if (!auth) {
    return children;
  }
  return <AuthHydrator auth={auth} data-sentry-element="AuthHydrator" data-sentry-component="AuthHydrationProvider" data-sentry-source-file="AuthHydrationProvider.tsx">{children}</AuthHydrator>;
};